var ccErrorNo = 0;
var ccErrors = new Array();

ccErrors[0] = "Type de carte Inconnu";
ccErrors[1] =
    "Aucun numéro de carte n'a été saisi.\n Merci de renseigner votre numéro de carte bancaire.";
ccErrors[2] = "Le format de votre numéro de carte est invalide";
ccErrors[3] = "Le numéro de votre carte est invalide";
ccErrors[4] = "Le numéro de votre carte n'a pas la bonne longueur";
ccErrors[5] =
    "Le Code de vérification ou le cryptogramme visuel de votre carte est invalide";
ccErrors[6] = "Aucun nom n'a été saisi.\nMerci de renseigner votre nom";
ccErrors[7] = "La date d'expiration de votre carte est incorrecte";

var last_err_input = null;

try {
    var alias_verif = document.getElementById("do_alias").value;
} catch (e) {}
var block_redirection = false;

function changeCarte(nom, num, mois, annee, id) {
    var checkbox_checked = true;

    if (nom === undefined) {
        var ladate = new Date();

        id = 0;
        nom = "";
        num = "";
        mois = "01";
        annee = ladate.getFullYear();
        checkbox_checked = false;

        if (!$("#name_without_card").is(":focus")) {
            $("#name_without_card").focus();
        }
    }

    $("#alias_id").val(id);
    $("#name_without_card").val(nom);
    $("#numero_without_card").val(num);
    $("#date_exp_mois").val(mois);
    $("#date_exp_mois")
        .closest(".selectStyled")
        .find(".clone")
        .html(mois);
    $("#date_exp_annee").val(annee);
    $("#date_exp_annee")
        .closest(".selectStyled")
        .find(".clone")
        .html(annee);
    $("#bloc_other_alias").slideUp();

    is_deplie = false;

    document.getElementById("do_alias").checked = checkbox_checked;
}

var is_deplie = false;

function deleteFlexAlias(evt) {
    var alias = this.form;
    var alias_id = alias.alias_id.value.trim();

    var parent = $(alias.parentElement);

    evt.preventDefault();

    $.ajax({
        url: path_relative_root + create_link('ajax_delete_alias'),
        method: "GET",
        data: {id: alias_id},
        success: function(res) {
            if (res == 1) {
                parent.animate({height: 0, opacity: 0}, 350, function() {
                    parent.remove();
                });
            }
        },
    });

    return false;
}

$(function() {
    "use strict";

    $("form.alias").on("input", "input[name=cvc]", function() {
        var val = this.value.trim();

        $("button.use", this.form).prop("disabled", val.length < 3);
    });

    $("form.alias").on("click", "button.use", function() {
        if (!$(this).is("disabled")) {
            $(this).addClass("loading");
        }
    });
});
